import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { SharedModule } from 'shared/shared.module';

import { SliceAbTestingRenderComponent } from './render/slice-ab-testing-render.component';


export const sliceAbTestingRenderModuleEntryComponents = [
  SliceAbTestingRenderComponent,
];

@NgModule({
  imports: [
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule,
  ],
  exports: [
    sliceAbTestingRenderModuleEntryComponents
  ],
  declarations: sliceAbTestingRenderModuleEntryComponents
})
export class SliceAbTestingRenderModule {}

export default sliceAbTestingRenderModuleEntryComponents;
